import { useEffect, useState } from "react";
import { InputAutocompleteOptions } from "../input";
import { AutocompleteOption } from "../AutocompleteSearch";

interface IuseGenerateOptions {
  dataSource?: any[];
  keyForText: string;
  keyForValue: string;
}

interface IuseGenerateOptions {
  dataSource?: any[];
  idKey: string;
  valueKey: string;
}

interface IuseGenerateArrayFromObj {
  dataSource?: Object;
}

interface IOptions {
  text: string;
  value: any;
}

interface IuseGenerateOptions2 {
  dataSource?: any[];
  keyForText: string;
  keyForValue: string;
}

const useGenerateOptions2 = ({
  dataSource,
  keyForText,
  keyForValue,
}: IuseGenerateOptions2) => {
  const [dataOptions, setDataOptions] = useState<IOptions[]>([]);

  useEffect(() => {
    //&& dataOptions.length <= 0
    if (dataSource) {
      const temp: IOptions[] = [];
      dataSource.forEach((item) => {
        temp.push({
          text: item[keyForText],
          value: item[keyForValue],
        });
      });
      setDataOptions(temp);
    }
  }, [dataSource]);

  return { data: dataOptions };
};

const useGenerateNewAutoCompleteOptions = ({
  dataSource,
  keyForText,
  keyForValue,
}: IuseGenerateOptions2) => {
  const [dataOptions, setDataOptions] = useState<InputAutocompleteOptions[]>(
    []
  );

  useEffect(() => {
    //&& dataOptions.length <= 0
    if (dataSource) {
      const temp: InputAutocompleteOptions[] = [];
      dataSource.forEach((item) => {
        temp.push({
          label: item[keyForText],
          id: item[keyForValue],
        });
      });
      setDataOptions(temp);
    }
  }, [dataSource]);

  return { data: dataOptions };
};

const useGenerateOptionsv2 = ({
  dataSource,
  keyForText,
  keyForValue,
}: IuseGenerateOptions) => {
  const [dataOptions, setDataOptions] = useState<IOptions[]>([]);

  useEffect(() => {
    if (dataSource) {
      const temp: IOptions[] = [];
      dataSource.forEach((item) => {
        temp.push({
          text: item[keyForText],
          value: item[keyForValue],
        });
      });
      setDataOptions(temp);
    }
  }, [dataSource]);

  return { data: dataOptions };
};

const useGenerateAutoCompleteSearch = ({
  dataSource,
  keyForText,
  keyForValue,
}: IuseGenerateOptions2) => {
  const [dataOptions, setDataOptions] = useState<AutocompleteOption[]>([]);

  useEffect(() => {
    //&& dataOptions.length <= 0
    if (dataSource) {
      const temp: AutocompleteOption[] = [];
      dataSource.forEach((item) => {
        temp.push({
          label: item[keyForText],
          value: item[keyForValue],
        });
      });
      setDataOptions(temp);
    }
  }, [dataSource]);

  return { data: dataOptions };
};

const useGenerateOptions = ({
  dataSource,
  idKey,
  valueKey,
}: IuseGenerateOptions) => {
  const [dataOptions, setDataOptions] = useState<InputAutocompleteOptions[]>(
    []
  );

  useEffect(() => {
    if (dataSource) {
      const temp: InputAutocompleteOptions[] = [];
      dataSource.forEach((item) => {
        temp.push({
          id: item[idKey],
          label: item[valueKey],
        });
      });
      setDataOptions(temp);
    }
  }, [dataSource]);

  return { data: dataOptions };
};

const useGenerateArrayFromObj = ({ dataSource }: IuseGenerateArrayFromObj) => {
  const [result, setResult] = useState<IOptions[]>([]);

  useEffect(() => {
    if (dataSource && result.length <= 0) {
      const temp: IOptions[] = [];
      Object.entries(dataSource).map((item) => {
        temp.push({
          text: item[0],
          value: item[1],
        });
      });
      setResult(temp);
    }
  }, [dataSource]);

  return { data: result };
};

export {
  useGenerateArrayFromObj,
  useGenerateOptions2,
  useGenerateNewAutoCompleteOptions,
  useGenerateAutoCompleteSearch,
  useGenerateOptionsv2,
};

export default useGenerateOptions;
